import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./TextIconTiles.css";
import { TextIconTilesProps } from "./TextIconTilesInterface";

const TextIconTiles: React.FC<TextIconTilesProps> = ({
  child,
  hideMobile = false,
}) => {
  const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const isMobile = hideMobile && isMobileScreen;
  if (child.length === 0 || isMobile) return null;
  return (
    <Box className="text-tiles" sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} justifyContent="center">
        {child.map((card) => (
          <Grid item xs={12} sm={4} md={4} key={card.id}>
            <Card
              className="text-card"
              sx={{ backgroundColor: "primary.light" }}
            >
              <CardContent className="text-tile-cardContent">
                <Box
                  className="image-container"
                  sx={{ backgroundColor: "primary.main" }}
                >
                  <Box
                    component="img"
                    className="icon-img"
                    alt={card.id}
                    src={card.image}
                  />
                </Box>
                <Typography component="p" className="card-text">
                  {card.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TextIconTiles;
